import { defaultIntensityRange } from '../../../../../../cross-team-shared/state/layer-settings-state-3d';
import { Range } from '../../../../../../cross-team-shared/types/misc';
import {
  cloudPalette,
  groundPalette,
  PointCloudPalette,
} from '../../../../../render/mesh/cloud/point-cloud-palette';
import { PointCloudContentState } from '../../../../../state/point-cloud-content-state';
import { CloudShaderMaterial } from '../../../cloud-shader-material';

export interface IntensityModeUniforms {
  cloudPalette: PointCloudPalette;
  groundPalette: PointCloudPalette;
  intensityRange: Range;
}

export const intensityModeUniforms = `
  struct IntensityModeUniforms {
    HSVPalette cloudPalette;
    HSVPalette groundPalette;
    Range intensityRange;
  };
`;

export const getColorForIntensityMode = `
  // attribute uint instanceId; -- Defined on base class
  attribute float intensity;

  HSVPalette getPointPalette() {
    HSVPalette cloudPalette = color.intensity.cloudPalette;
    HSVPalette groundPalette = color.intensity.groundPalette;

    if(instanceId == CLOUD_INSTANCE_ID) {
      return cloudPalette;
    } else {
      return groundPalette;
    }
  }

  vec3 getIntensityColor(HSVPalette palette) {
    Range intensityRange = color.intensity.intensityRange;

    float factor = (intensity - intensityRange.min) / (intensityRange.max - intensityRange.min);
    return palette.min + (palette.max - palette.min) * factor;
  }

  vec4 getColorForIntensityMode() {
    HSVPalette pointPalette = getPointPalette();
    Range intensityRange = color.intensity.intensityRange;

    if (intensityRange.min <= intensity && intensity <= intensityRange.max) {
      return hsvToRgba(getIntensityColor(pointPalette));
    } else {
      return hsvToRgba(pointPalette.withoutIntensity);
    }
  }
`;

export function setIntensityModeUniforms(
  material: CloudShaderMaterial,
  state?: PointCloudContentState,
) {
  const uniforms: IntensityModeUniforms = {
    cloudPalette,
    groundPalette,
    intensityRange:
      state?.render.layerSettings.intensityRange ?? defaultIntensityRange,
  };

  material.defaultAttributeValues.intensity = [-1];
  material.setColorUniform('intensity', uniforms);
}
